import React from 'react';
import Meta from '../components/Meta';

const TermsOfUse = () => {
  return (
    <div>
      <Meta title="Terms of Use - Software Talks"/>
      <div className="pt-[5.5rem] lg:pt-24">
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full"/>
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Terms Of Use
            </h1>
            <h2 className="text-center">Updated October 20, 2019</h2>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <p>By using SoftwareTalks web site (`Service`), you are agreeing to be bound to the following terms and conditions (`Terms of Service`).</p>
              <p>SoftwareTalks reserves the right to update and change the Terms of Service at it`s discretion without notice. Any new features in excess to the current Service shall be subject to the
                Terms of Service. Continued use of the Service after any such changes shall constitute your consent to such changes.</p>

              <h2>Account Terms</h2>
              <p>You must provide your legal full name, a valid email address, and any other pertinent information requested in order to complete the sign-up process.</p>

              <h2>Account Deletion and Termination</h2>
              <p>It is your responsibility to ensure that your account has been properly canceled. An email requesting an account to be canceled is not considered a cancellation. You can delete your
              account at any time from the `Account` section within the Service.</p>
              <p>All of your Content will be immediately removed from the Service should you initiate deletion. This information can not be recovered once your account is deleted.</p>
              <p>Your deletion will be effective immediately once initiated. You will not be charged again from that point forward.</p>
              <p>SoftwareTalks has the right to suspend or terminate your account and refuse any and all current or future use of the Service for any reason at any time. SoftwareTalks, in it`s sole
              discretion, reserves the right to refuse service to anyone for any reason at any time.</p>

              <h2>General Conditions</h2>
              <p>Your use of the Service is at your own risk. The service is provided on an `as is` and `as available` basis.</p>
              <p>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUse;
